import { render } from "./BarcodeHistoryDialog.vue?vue&type=template&id=7a8d372e"
import script from "./BarcodeHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./BarcodeHistoryDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script